<template>
  <div class="person">
    <DomainTree v-if="$route.path === '/basicdata/personnelmanagement'" @isCollapse-treedata="isCollapseTreedata" @addcheck-treedata="getTreeCheckData" :checkDomainId="domainId" :orgData="orgData" :orgTreeData="orgTreeData" :oneNodeArr="oneNodeArr"></DomainTree>
    <div v-if="$route.path === '/basicdata/personnelmanagement'" class="right" :style="styleRight">
      <div class="operation">
        <div class="operationBtn">
          <el-dropdown trigger="click">
            <el-button :disabled="delDisabled">{{$t('LanguageLib.BATCH_SET')}}</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :title="$t('LanguageLib.RESET_PASSWORD')" @click.native.prevent="resetPassword">{{$t('LanguageLib.RESET_PASSWORD')}}</el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.DELETE')" @click.native.prevent="delPersonData">{{$t('LanguageLib.DELETE')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="addPerson">{{$t('LanguageLib.ADD_TO')}}</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-dropdown trigger="click">
            <el-button type="primary" style="margin-left: 0;">{{$t('LanguageLib.ImportOrExport')}}</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :title="$t('LanguageLib.DOWNLOAD_TEMPLATE')" @click.native.prevent="downExcal">{{$t('LanguageLib.DOWNLOAD_TEMPLATE')}}</el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.IMPORTER')">
                <el-upload
                  class="upload"
                  name="files"
                  :data="formData"
                  :action="uploadApi"
                  :headers="headers()"
                  :on-preview="handlePreview"
                  :before-upload="beforeUpload"
                  :on-error="onError"
                  :on-success="(file, response) => {onSuccess(file, response, 1000)}"
                  :show-file-list="false"
                  accept=".xlsx, .xls">
                  <el-button :plain="true" style="padding: 0px;border: none;color: #666;">{{$t('LanguageLib.IMPORTER')}}</el-button>
                </el-upload>
              </el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.EXPORT_PEOPLE')" @click.native.prevent="exportExcal">{{$t('LanguageLib.EXPORT_PEOPLE')}}</el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.DOWNLOAD_POSITION_TEMPLATE')" @click.native.prevent="downExcal2(8)">{{$t('LanguageLib.DOWNLOAD_POSITION_TEMPLATE')}}</el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.IMPORT_PERSONNEL_POSITION')">
                <el-upload
                  class="upload2"
                  name="files"
                  :data="formData"
                  :action="uploadApi"
                  :headers="headers()"
                  :on-preview="handlePreview"
                  :before-upload="beforeUpload"
                  :on-error="onError"
                  :on-success="(file, response) => {onSuccess(file, response, 14000)}"
                  :show-file-list="false"
                  accept=".xlsx, .xls">
                  <el-button :plain="true" style="padding: 0px;border: none;color: #666;">{{$t('LanguageLib.IMPORT_PERSONNEL_POSITION')}}</el-button>
                </el-upload>
              </el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.EXPORT_STAFF')" @click.native.prevent="exportExcalPosition">{{$t('LanguageLib.EXPORT_STAFF')}}</el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.DOWNLOAD_EXCEL_QYTEMPLATE')"
                                @click.native.prevent="downExcal2(21)">{{$t('LanguageLib.DOWNLOAD_EXCEL_QYTEMPLATE')}}
              </el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.QY_PRE_BINDING')">
                <el-upload
                  class="upload2"
                  name="files"
                  :data="formData"
                  :action="uploadApi"
                  :headers="headers()"
                  :on-preview="handlePreview"
                  :before-upload="beforeUpload"
                  :on-error="onError"
                  :on-success="(file, response) => {onSuccess(file, response, 1010)}"
                  :show-file-list="false"
                  accept=".xlsx, .xls">
                  <el-button :plain="true" style="padding: 0px;border: none;color: #666;">
                    {{$t('LanguageLib.QY_PRE_BINDING')}}
                  </el-button>
                </el-upload>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="operationSearch">
          <i @click="drawerOpen" style="cursor: pointer;" class="iconfont shaixuan" :class="{'shaixuan1' : shaixuan}">&#xe624;</i>
          <span v-show="isSearch" style="color:#666;font-size:14px;">{{$t('LanguageLib.SearchedOut')}}<span class="colorG">{{ pageTotal }} &nbsp;</span>{{$t('LanguageLib.Results')}}</span>
          <i v-show="isSearch" @click="clearSearchData" class="el-icon-close" style="margin:0 10px 0 10px;color:#666;font-size:14px;cursor: pointer;"></i>
          <el-input
            placeholder=""
            prefix-icon="el-icon-search"
            v-model="searchText"
            @keyup.enter.native="searchDomainList"
          >
          </el-input>
        </div>
      </div>
      <div class="tableParent">
        <el-table
          empty-text=" "
          class="table-fixed"
          :data="tableData"
          stripe
          @selection-change="selectionChange"
          @sort-change='sortChange'
          style="width: auto;"
          v-loading="loading"
          ref="listPowerSupplyTab"
          :default-sort="defaultSort"
          height="100%">
          <el-table-column
            type="selection"
            width="45">
          </el-table-column>
          <el-table-column
            prop="userName"
            :label="$t('LanguageLib.NAME')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope" class="code">
              <el-tooltip class="code" effect="light" placement="top-start" >
                <span v-if="!$commonfun.iswx(scope.row.userName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))" slot="content" type="userName">{{scope.row.userName}}</span>
                <span v-if="!$commonfun.iswx(scope.row.userName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" ref="toolTipItem"  type="userName">{{scope.row.userName}}</span>
                <span v-if="$commonfun.iswx(scope.row.userName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))" slot="content" type="userName">
                  <ww-open-data slot="content" type="userName" :openid="scope.row.userName.slice(3)"></ww-open-data>
                </span>
                <span v-if="$commonfun.iswx(scope.row.userName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" ref="toolTipItem" type="userName">
                  <ww-open-data slot="content" type="userName" :openid="scope.row.userName.slice(3)"></ww-open-data>
                </span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="userAccount"
            :label="$t('LanguageLib.ACCOUNT')"
            sortable="custom"
            min-width="180">
            <template slot-scope="scope" class="code">
              <el-tooltip effect="light" placement="top-start" class="code">
                <span slot="content" type="userAccount">{{scope.row.userAccount}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="userAccount">{{scope.row.userAccount}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="displayPosition"
            :label="$t('LanguageLib.POSITION')"
            min-width="200">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <!-- 如果没有填入职位显示组织加角色 -->
                <span v-if="!scope.row.displayPosition" slot="content" type="displayPosition">
                  <span v-html="$commonfun.RenderWxName('departmentName', scope.row.domainName)"></span>&nbsp;<span>{{scope.row.roleName}}</span>
                </span>
                <span v-if="!scope.row.displayPosition" ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="displayPosition">
                  <span v-html="$commonfun.RenderWxName('departmentName', scope.row.domainName)"></span>&nbsp;<span>{{scope.row.roleName}}</span>
                </span>
                <!-- 如果有职位显示职位 -->
                <span v-if="scope.row.displayPosition" slot="content" type="displayPosition">{{scope.row.displayPosition}}</span>
                <span v-if="scope.row.displayPosition" ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="displayPosition">{{scope.row.displayPosition}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="workEmail"
            :label="$t('LanguageLib.MAILBOX')"
            sortable="custom"
            min-width="210">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="workEmail">{{scope.row.workEmail}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="workEmail">{{scope.row.workEmail}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="rank"
            :label="$t('LanguageLib.USER_TYPE')"
            min-width="150">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="rank">{{$commonfun.getUserTypeName(scope.row.rank)}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="rank">{{$commonfun.getUserTypeName(scope.row.rank)}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="stateValue"
            :label="$t('LanguageLib.STATUS')"
            sortable="custom"
            min-width="130">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="stateValue">{{$commonfun.getPeopleStatus(scope.row.stateValue)}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="stateValue">{{$commonfun.getPeopleStatus(scope.row.stateValue)}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="endDate"
            :label="$t('LanguageLib.EXPIRATION_DATE')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="endDate">{{$commonfun.formatDate(scope.row.endDate, '2')}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="endDate">{{$commonfun.formatDate(scope.row.endDate, '2')}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="authStatus"
            :label="$t('LanguageLib.Is_Enterprise_Micro_Synchronization')"
            min-width="130">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="currencyType">{{$commonfun.isQySynchronization1(scope.row.authStatus)}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="currencyType">{{$commonfun.isQySynchronization1(scope.row.authStatus)}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="updateDate"
            :label="$t('LanguageLib.LAST_UPDATED')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="lastLoginDate">{{$commonfun.formatDate(scope.row.updateDate, '1')}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="lastLoginDate">{{$commonfun.formatDate(scope.row.updateDate, '1')}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="lastLoginDate"
            :label="$t('LanguageLib.Latest_Login_Time')"
            sortable="custom"
            min-width="170">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="lastLoginDate">{{$commonfun.formatDate(scope.row.lastLoginDate, '1')}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="lastLoginDate">{{$commonfun.formatDate(scope.row.lastLoginDate, '1')}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$t('LanguageLib.Operation')"
            min-width="100">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="editPerson(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.Edit')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe60c;</i>
              </el-button>
              <el-button
                @click.native.prevent="positionInformation(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.Position_Information')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe606;</i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
    <el-drawer
      v-if="$route.path === '/basicdata/personnelmanagement'"
      :visible.sync="drawer"
      :show-close="true"
      :modal="false"
      :wrapperClosable="false"
      size="420px"
      :with-header="false">
      <div style="overflow: hidden">
        <p style="float: left;" class="drawerTitle">{{$t('LanguageLib.Filter')}}</p>
        <el-button @click="drawerClose" style="float: right;padding: 4px 0 0 0;font-size: 18px;color: #4d4d4d;" type="text"><i class="el-icon-close"></i></el-button>
      </div>
      <div class="filterContent" style="padding-right: 10px;">
        <p class="drawerText">{{$t('LanguageLib.GENDER')}}</p>
        <el-select style="width: 100%;" v-model="checkedGender" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
          <el-option
            v-for="item in GenderList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <p class="drawerText">{{$t('LanguageLib.ROLES')}}</p>
        <el-select multiple filterable v-model="checkedRoles" :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
          <el-option
            v-for="item in roleList"
            :key="item.roleId"
            :label="item.roleName"
            :value="item.roleId">
          </el-option>
        </el-select>
        <p class="drawerText">{{$t('LanguageLib.USER_TYPE')}}</p>
        <el-select multiple filterable v-model="checkedUserType" :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
          <el-option
            v-for="item in UserTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <p class="drawerText">{{$t('LanguageLib.ADMINISTRATOR')}}</p>
        <el-select style="width: 100%;" v-model="checkedAdminStatus" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
          <el-option
            v-for="item in AdminStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <p class="drawerText">{{$t('LanguageLib.LOGIN_PROTECTION')}}</p>
        <el-select style="width: 100%;" v-model="checkedProtectStatus" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
          <el-option
            v-for="item in ProtectStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <p class="drawerText">{{$t('LanguageLib.Lock_In_People')}}</p>
        <el-select style="width: 100%;" v-model="checkedLockStatus" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
          <el-option
            v-for="item in LockStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="float: right;margin-top: 10px;">
        <el-button @click="resetSearchData" style="height: 30px;padding: 7px 20px;" class="resetBtn">{{$t('LanguageLib.RESET')}}</el-button>
        <el-button @click="searchOrgList" style="height: 30px;padding: 7px 20px;" type="primary" class="searchBtn">{{$t('LanguageLib.SEARCH_FOR')}}</el-button>
      </div>
    </el-drawer>
    <!--重置密码-->
    <el-dialog :title="$t('LanguageLib.RESET_PASSWORD')" :visible.sync="dialogReset" class="resetDialog dialogAdd" :before-close="closeDialog" :close-on-click-modal="false">
      <el-form>
        <div class="parent">
          <el-checkbox v-model="SendSMS">{{$t('LanguageLib.SEND_SMS_NOTIFICATION')}}</el-checkbox>
        </div>
        <div class="parent">
          <el-checkbox v-model="SendMail">{{$t('LanguageLib.SEND_MAIL_NOTIFICATION')}}</el-checkbox>
        </div>
        <div v-if="SendMail == true" >
          <div class="parent" style="padding-left: 12px;" v-for="item in ResetData" :key="item.label">
            <el-radio v-model="Lang" :label="item.label">{{item.name}}</el-radio>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitReset()">{{$t('LanguageLib.DETERMINE')}}</el-button>
      </div>
    </el-dialog>
    <!--导出人员excal-->
    <el-dialog :title="$t('LanguageLib.SELECT_EXPORT_FIELD')" :visible.sync="dialogExcal" class="ExcalDialog dialogList" :before-close="closeDialogExcal" :close-on-click-modal="false">
      <div class="checkFiled">
        <el-form>
          <div class="contentTop">
              <el-radio v-model="allField" :label="item.label" v-for="item in FieldData" :key="item.label" @change="handleCheckAllChange">{{item.name}}</el-radio >
          </div>
          <div class="basicsField">
            <h4>{{$t('LanguageLib.BASE_FIELD')}}</h4>
            <div class="basicsFieldChild">
              <el-checkbox-group v-model="checkedFields">
                <el-checkbox v-for="item in Fields" :label="item" :key="item" :disabled="allField == '2'">{{item}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="customField">
            <h4>{{$t('LanguageLib.CUSTOM_FIELD')}}</h4>
          </div>
        </el-form>
      </div>
      <div class="showFiled">
        <p style="color: #999999;">{{$t('LanguageLib.CURRENT_SELECT_FIELD')}}</p>
        <ul>
          <li v-for="item in checkedFields" :key="item"><span>{{item}}</span><i class="el-icon-close" @click="delField(item)" v-if="allField == '1'"></i></li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit()" :loading="loadingSave">{{$t('LanguageLib.DETERMINE')}}</el-button>
      </div>
    </el-dialog>
    <!--导出人员职位excal-->
    <el-dialog :title="$t('LanguageLib.SELECT_EXPORT_FIELD')" :visible.sync="dialogExcal2" class="ExcalDialog dialogList" :before-close="closeDialogExcal2" :close-on-click-modal="false">
      <div class="checkFiled">
        <el-form>
          <div class="contentTop">
              <el-radio v-model="allField2" :label="item.label" v-for="item in FieldData2" :key="item.label" @change="handleCheckAllChange2">{{item.name}}</el-radio >
          </div>
          <div class="basicsField">
            <h4>{{$t('LanguageLib.BASE_FIELD')}}</h4>
            <div class="basicsFieldChild">
              <el-checkbox-group v-model="checkedFields2">
                <el-checkbox v-for="item in Fields2" :label="item" :key="item" :disabled="allField2 == '2'">{{item}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="customField">
            <h4>{{$t('LanguageLib.CUSTOM_FIELD')}}</h4>
          </div>
        </el-form>
      </div>
      <div class="showFiled">
        <p style="color: #999999;">{{$t('LanguageLib.CURRENT_SELECT_FIELD')}}</p>
        <ul>
          <li v-for="item in checkedFields2" :key="item"><span>{{item}}</span><i class="el-icon-close" @click="delField2(item)" v-if="allField2 == '1'"></i></li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit2()" :loading="loadingSave2">{{$t('LanguageLib.DETERMINE')}}</el-button>
      </div>
    </el-dialog>
    <router-view v-if="$route.path !== '/basicdata/personnelmanagement'"></router-view>
  </div>
</template>

<script>
import basicdataApi from '../../api/basicdata'
import DomainTree from '@/components/DomainTree.vue'
import baseUrl from '@/utils/base'
export default {
  name: 'domainsetting',
  components: { DomainTree },
  props: {
    msg: String
  },
  data () {
    return {
      uploadApi: baseUrl.uploadApi, // 上传地址
      dialogReset: false, // 是否显示重置密码弹框
      ResetData: [
        {
          name: this.$t('LanguageLib.SIMPLIFIED_CHINESE'),
          label: '0'
        },
        {
          name: this.$t('LanguageLib.TRADITIONAL_CHINESE'),
          label: '1'
        },
        {
          name: this.$t('LanguageLib.ENGLISH'),
          label: '2'
        },
        {
          name: this.$t('LanguageLib.JAPANESE'),
          label: '3'
        },
        {
          name: this.$t('LanguageLib.KOREAN'),
          label: '4'
        }
      ],
      SendSMS: true, // 重置密码发送短信
      SendMail: false, // 重置密码发送邮件
      Lang: this.$commonfun.localStorage.getitem('OwnerLanguage'), // 发送邮件多语言
      loading: true, // loading状态
      isSearch: false, // 是否为搜索状态
      dialogExcal: false, // 是否显示导出excal弹框-人员
      dialogExcal2: false, // 是否显示导出excal弹框-人员职位
      orgTreeData: [], // 组织树数据
      orgData: [], // 组织树源数据
      oneNodeArr: [], // 一级组织下的数据
      tableData: [], // 列表数据
      pageTotal: 0, // 数据总数
      shaixuan: false, // 漏斗图是否高亮
      formData: { path: 'images' },
      selectPersonData: [], // 选中的要删除的人员数据
      GenderList: [{
        value: 0,
        label: this.$t('LanguageLib.FEMALE')
      }, {
        value: 1,
        label: this.$t('LanguageLib.MALE')
      }, {
        value: 2,
        label: this.$t('LanguageLib.UNSPECIFIED')
      }], // 性别列表
      UserTypeList: [{
        value: 1,
        label: this.$t('LanguageLib.RETAIL_MANAGEMENT')
      }, {
        value: 2,
        label: this.$t('LanguageLib.STORE_MANAGEMENT')
      }, {
        value: 3,
        label: this.$t('LanguageLib.Store_Staff')
      }, {
        value: 4,
        label: this.$t('LanguageLib.Non_Retail_System')
      }], // 用户类型列表
      AdminStatusList: [{
        value: 0,
        label: this.$t('LanguageLib.No_ADMINISTRATOR')
      }, {
        value: 1,
        label: this.$t('LanguageLib.ADMINISTRATOR')
      }], // 管理员状态列表
      ProtectStatus: [{
        value: 0,
        label: this.$t('LanguageLib.Not_Open')
      }, {
        value: 1,
        label: this.$t('LanguageLib.Open')
      }], // 登录保护状态
      LockStatus: [{
        value: 0,
        label: this.$t('LanguageLib.LOCKING')
      }, {
        value: 1,
        label: this.$t('LanguageLib.UNLOCKED')
      }], // 锁定人员状态
      roleList: [], // 角色列表
      getPeopleListFun: (pageIndex, pageSize, domainId, searchVal, sort, isAsc, gender, roleIds, ranks, isAdmin, isLoginProtection, isLock) => {
        this.loading = true
        // 请求列表接口数据
        if (domainId === '') {
          domainId = null
        }
        basicdataApi.getPeopleList('post', '/user/list', { pageIndex, pageSize, domainId, searchVal, sort, isAsc, gender, roleIds, ranks, isAdmin, isLoginProtection, isLock })
          .then(res => {
            this.tableData = res.data.data
            this.pageTotal = res.data.total
            this.loading = false
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }, // 请求数据列表的函数
      searchText: '', // 列表搜索关键词
      domainId: '', // 列表请求domainId
      currentPage: 1, // 默认显示第1页数据
      pageSize: 20, // 默认每页显示20条数据
      sort: 8, // 排序字段1.用户名2.帐号3.职位4.状态5.邮箱6.有效期7.最后更新时间 8最近更新时间
      isAsc: false, // 是否正序
      gender: -1, // 性别
      ranks: [], // 用户类型列表-1:无1：零售管理员2：店铺管理员3：店铺员工4：非零售系统
      roleIds: [], // 角色ID列表
      isAdmin: -1, // 是否管理员-1：all0:否1：是
      isLoginProtection: -1, // 是否登录保护-1:all0:否1：是
      isLock: -1, // 是否锁定-1:all0:锁定1：非锁定
      delDisabled: true, // 删除按钮默认禁用
      drawer: false, // 抽屉框默认收起
      checkedGender: '', // 抽屉框选中性别
      checkedRoles: [], // 抽屉框选中角色
      checkedUserType: [], // 抽屉框选中用户类型
      checkedAdminStatus: '', // 抽屉框选中管理员状态
      checkedProtectStatus: '', // 抽屉框选中登录保护状态
      checkedLockStatus: '', // 抽屉框选中锁定人员状态
      styleRight: 'width: 80%;margin-left: 20%', // right默认宽度
      defaultSort: { prop: 'updateDate', order: 'descending' }, // 默认显示排序
      prevSort: 'descending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp: 'updateDate', // 记录前一次的prop值
      updataRouteQuery: () => {
        const query = this.$router.history.current.query
        const path = this.$router.history.current.path
        const newQuery = JSON.parse(JSON.stringify(query))
        this.$commonfun.console.log(this.currentPage)
        newQuery.currentPage = this.currentPage
        newQuery.pageSize = this.pageSize
        newQuery.checkDomainId = this.domainId
        newQuery.searchText = this.$commonfun.encodeUrl(this.searchText)
        newQuery.sort = this.sort
        newQuery.isAsc = this.isAsc
        newQuery.gender = this.gender
        newQuery.ranks = this.ranks
        newQuery.roleIds = this.roleIds
        newQuery.isAdmin = this.isAdmin
        newQuery.isLoginProtection = this.isLoginProtection
        newQuery.isLock = this.isLock
        newQuery.NoRefresh = true
        this.$router.push({ path, query: newQuery })
      },
      FileData: {
        FileName: '', // 文件名称
        FilePath: '', // 文件地址
        EnumImportType: 14000 // 导入类型 14000为人员导入
      }, // 人员职位文件导入参数
      loadingSave: false, // 保存按钮加loding-人员
      loadingSave2: false, // 保存按钮加loding-人员职位
      allField: '2', // 导出excal-所有字段-人员
      allField2: '2', // 导出excal-所有字段-人员职位
      FieldData: [
        // {
        //   name: this.$t('LanguageLib.SELECT_VIEW'),
        //   label: '1'
        // },
        {
          name: this.$t('LanguageLib.EXPORT_FOLLOW_UP'),
          label: '2'
        }
      ], // 导出查看/导出跟进-人员
      FieldData2: [
        // {
        //   name: this.$t('LanguageLib.SELECT_VIEW'),
        //   label: '1'
        // },
        {
          name: this.$t('LanguageLib.EXPORT_FOLLOW_UP'),
          label: '2'
        }
      ], // 导出查看/导出跟进-人员职位
      checkedFields: [this.$t('LanguageLib.NAME'), this.$t('LanguageLib.ACCOUNT'), this.$t('LanguageLib.ROLES'), this.$t('LanguageLib.ORGANIZATIONDEPARTMENT_NAME'), this.$t('LanguageLib.STATUS'), this.$t('LanguageLib.USER_TYPE'), this.$t('LanguageLib.z_info_common_000068'), this.$t('LanguageLib.SUPERIOR_NAME'), this.$t('LanguageLib.SUPERIOR_ACCOUNT'), this.$t('LanguageLib.GENDER'), this.$t('LanguageLib.BIRTH_DAY'), this.$t('LanguageLib.EXPIRATION_DATE'), this.$t('LanguageLib.MAILBOX'), this.$t('LanguageLib.CONTACT_DETAILS'), this.$t('LanguageLib.z_info_common_000076')], // 已选中的字段-人员
      checkedFields2: [this.$t('LanguageLib.NAME'), this.$t('LanguageLib.NAME_OF_ASSOCIATION'), this.$t('LanguageLib.ROLES')], // 已选中的字段-人员职位
      Fields: [this.$t('LanguageLib.NAME'), this.$t('LanguageLib.ACCOUNT'), this.$t('LanguageLib.ROLES'), this.$t('LanguageLib.ORGANIZATIONDEPARTMENT_NAME'), this.$t('LanguageLib.STATUS'), this.$t('LanguageLib.USER_TYPE'), this.$t('LanguageLib.z_info_common_000068'), this.$t('LanguageLib.SUPERIOR_NAME'), this.$t('LanguageLib.SUPERIOR_ACCOUNT'), this.$t('LanguageLib.GENDER'), this.$t('LanguageLib.BIRTH_DAY'), this.$t('LanguageLib.EXPIRATION_DATE'), this.$t('LanguageLib.MAILBOX'), this.$t('LanguageLib.CONTACT_DETAILS'), this.$t('LanguageLib.z_info_common_000076')],
      Fields2: [this.$t('LanguageLib.NAME'), this.$t('LanguageLib.NAME_OF_ASSOCIATION'), this.$t('LanguageLib.ROLES')]
    }
  },
  created () {
    if (this.$route.query.currentPage) {
      this.currentPage = this.$route.query.currentPage * 1
      this.pageSize = this.$route.query.pageSize * 1
      this.domainId = this.$route.query.checkDomainId
      this.searchText = this.$commonfun.decodeUrl(this.$route.query.searchText)
      this.sort = this.$route.query.sort * 1
      this.isAsc = JSON.parse(this.$route.query.isAsc)
      this.gender = this.$route.query.gender * 1
      this.checkedGender = this.$route.query.gender * 1 === -1 ? '' : this.$route.query.gender * 1
      if (this.$route.query.ranks && this.$route.query.ranks !== '') {
        for (let i = 0; i < this.$route.query.ranks.split(',').length; i++) {
          this.ranks.push(Number(this.$route.query.ranks.split(',')[i]))
          this.checkedUserType.push(Number(this.$route.query.ranks.split(',')[i]))
        }
      } else {
        this.ranks = []
        this.checkedUserType = []
      }
      if (this.$route.query.roleIds && this.$route.query.roleIds !== '') {
        this.roleIds = this.$route.query.roleIds.split(',')
        this.checkedRoles = this.$route.query.roleIds.split(',')
      } else {
        this.roleIds = []
        this.checkedRoles = []
      }
      this.isAdmin = this.$route.query.isAdmin * 1
      this.checkedAdminStatus = this.$route.query.isAdmin * 1 === -1 ? '' : this.$route.query.isAdmin * 1
      this.isLoginProtection = this.$route.query.isLoginProtection * 1
      this.checkedProtectStatus = this.$route.query.isLoginProtection * 1 === -1 ? '' : this.$route.query.isLoginProtection * 1
      this.isLock = this.$route.query.isLock * 1
      this.checkedLockStatus = this.$route.query.isLock * 1 === -1 ? '' : this.$route.query.isLock * 1
      switch (this.sort) {
        case 1:
          if (this.isAsc) {
            this.defaultSort = { prop: 'userName', order: 'ascending' }
            this.prevSort = 'ascending'
          } else {
            this.defaultSort = { prop: 'userName', order: 'descending' }
            this.prevSort = 'descending'
          }
          this.prevProp = 'userName'
          break
        case 2:
          if (this.isAsc) {
            this.defaultSort = { prop: 'userAccount', order: 'ascending' }
            this.prevSort = 'ascending'
          } else {
            this.defaultSort = { prop: 'userAccount', order: 'descending' }
            this.prevSort = 'descending'
          }
          this.prevProp = 'userAccount'
          break
        case 3:
          if (this.isAsc) {
            this.defaultSort = { prop: 'postionName', order: 'ascending' }
            this.prevSort = 'ascending'
          } else {
            this.defaultSort = { prop: 'postionName', order: 'descending' }
            this.prevSort = 'descending'
          }
          this.prevProp = 'postionName'
          break
        case 4:
          if (this.isAsc) {
            this.defaultSort = { prop: 'stateValue', order: 'ascending' }
            this.prevSort = 'ascending'
          } else {
            this.defaultSort = { prop: 'stateValue', order: 'descending' }
            this.prevSort = 'descending'
          }
          this.prevProp = 'stateValue'
          break
        case 5:
          if (this.isAsc) {
            this.defaultSort = { prop: 'workEmail', order: 'ascending' }
            this.prevSort = 'ascending'
          } else {
            this.defaultSort = { prop: 'workEmail', order: 'descending' }
            this.prevSort = 'descending'
          }
          this.prevProp = 'workEmail'
          break
        case 6:
          if (this.isAsc) {
            this.defaultSort = { prop: 'endDate', order: 'ascending' }
            this.prevSort = 'ascending'
          } else {
            this.defaultSort = { prop: 'endDate', order: 'descending' }
            this.prevSort = 'descending'
          }
          this.prevProp = 'endDate'
          break
        case 7:
          if (this.isAsc) {
            this.defaultSort = { prop: 'updateDate', order: 'ascending' }
            this.prevSort = 'ascending'
          } else {
            this.defaultSort = { prop: 'updateDate', order: 'descending' }
            this.prevSort = 'descending'
          }
          this.prevProp = 'updateDate'
          break
      }
    }
    if (this.checkedGender === '' && this.checkedRoles.length === 0 && this.checkedUserType.length === 0 && this.checkedAdminStatus === '' && this.checkedProtectStatus === '' && this.checkedLockStatus === '') {
      this.isSearch = false
      this.shaixuan = false
    } else {
      this.isSearch = true
      this.shaixuan = true
    }
    // 获取组织树列表
    basicdataApi.gettreelist('get', '/sysdomain/domainTree?showStore=' + true)
      .then(res => {
        this.orgData = res.data
        if (res.data.length > 0 && this.$route.query.currentPage === undefined) {
          // 'nextTick()' 下次dom更新时触发回调函数
          // 默认点击
          this.$nextTick().then(() => {
            if (document.querySelector('.el-tree-node__content')) {
              document.querySelector('.el-tree-node__content').click()
            }
          })
        }
        this.orgTreeData = this.$commonfun.toTree(res.data, 'childDomainTrees', 'id', 'parentDomainId')
        this.oneNodeArr.push(this.orgTreeData[0].id)
      })
      .catch(err => {
        this.$commonfun.console.log(err)
      })
    // 默认获取所有数据
    this.getPeopleListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.isAsc, this.gender, this.roleIds, this.ranks, this.isAdmin, this.isLoginProtection, this.isLock)
  },
  methods: {
    filterDomain () {
      basicdataApi.getSearchName('post', '/QYUser/Search',
        {
          ownerId: this.$commonfun.localStorage.getitem('ownerId'),
          ownerCode: this.$commonfun.localStorage.getitem('ownerCode'),
          search: this.filterText,
          queryType: 2
        }, 'Api')
        .then(res => {
          this.searchTreeIds = res.data
          this.$refs.tree.filter(this.filterText)
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    filterNode (value, data) {
      if (!value) {
        return true
      } else {
        return ''
      }
    },
    // 树组件传过来的数据
    getTreeCheckData (data) {
      this.domainId = data.id
      // 请求列表接口数据
      this.currentPage = 1
      this.pageSize = 20
      this.updataRouteQuery()
      this.getPeopleListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.isAsc, this.gender, this.roleIds, this.ranks, this.isAdmin, this.isLoginProtection, this.isLock)
    },
    // 显示隐藏组织树
    isCollapseTreedata (data) {
      this.$commonfun.console.log(data)
      if (data === true) {
        this.styleRight = 'width: calc(100% - 25px);margin-left: 25px;transition-property: width , margin-left; transition-duration:.28s , .28s;'
      } else {
        this.styleRight = 'width: 80%;margin-left: 20%;transition-property: width , margin-left; transition-duration:.28s , .28s;'
      }
    },
    // 列表排序
    sortChange (column) {
      if (column.order !== null) {
        this.prevSort = column.order
        if (column.order === 'ascending') {
          this.isAsc = true
          this.prevSort = 'ascending'
        } else if (column.order === 'descending') {
          this.isAsc = false
          this.prevSort = 'descending'
        }
        if (this.prevProp !== column.prop) {
          var columns = this.$refs.listPowerSupplyTab.columns.find(item => item.property === this.prevProp)
          columns.order = ''
        }
      }
      if (column.order === null) {
        column.column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        this.prevProp = column.prop
        this.prevSort = column.column.order
        this.isAsc = column.column.order !== 'descending'
      }
      switch (column.prop) {
        case 'userName':
          this.sort = 1
          break
        case 'userAccount':
          this.sort = 2
          break
        case 'postionName':
          this.sort = 3
          break
        case 'stateValue':
          this.sort = 4
          break
        case 'workEmail':
          this.sort = 5
          break
        case 'endDate':
          this.sort = 6
          break
        case 'updateDate':
          this.sort = 8
          break
        case 'lastLoginDate':
          this.sort = 7
          break
      }
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getPeopleListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.isAsc, this.gender, this.roleIds, this.ranks, this.isAdmin, this.isLoginProtection, this.isLock)
    },
    // 页数改变
    handleSizeChange (val) {
      this.pageSize = val
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getPeopleListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.isAsc, this.gender, this.roleIds, this.ranks, this.isAdmin, this.isLoginProtection, this.isLock)
    },
    // 每页条数改变
    handleCurrentChange (val) {
      this.currentPage = val
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getPeopleListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.isAsc, this.gender, this.roleIds, this.ranks, this.isAdmin, this.isLoginProtection, this.isLock)
    },
    // 列表模糊搜索
    searchDomainList () {
      this.currentPage = 1
      this.updataRouteQuery()
      this.getPeopleListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.isAsc, this.gender, this.roleIds, this.ranks, this.isAdmin, this.isLoginProtection, this.isLock)
    },
    // 重置密码
    resetPassword () {
      this.dialogReset = true
      this.SendSMS = true
      this.SendMail = false
      this.Lang = this.$commonfun.localStorage.getitem('OwnerLanguage')
    },
    // 关闭对话框  清除校验
    closeDialog () {
      this.dialogReset = false
    },
    // 确定重置密码
    submitReset () {
      basicdataApi.DelPersonList('post', '/user/resetpwd', {
        SendSMS: this.SendSMS,
        SendMail: this.SendMail,
        Ids: this.selectPersonData,
        Lang: Number(this.Lang)
      })
        .then(res => {
          // 获取组织树列表
          basicdataApi.gettreelist('get', '/sysdomain/domainTree')
            .then(res => {
              this.orgData = res.data
              this.orgTreeData = this.$commonfun.toTree(res.data, 'childDomainTrees', 'id', 'parentDomainId')
              this.oneNodeArr.push(this.orgTreeData[0].id)
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
          this.selectPersonData = []
          this.$refs.listPowerSupplyTab.clearSelection()
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.PASSWORD_RESET_SUCCEEDED')
          })
          this.dialogReset = false
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    // 删除人员数据
    delPersonData () {
      this.$commonfun.confirm(this.$t('LanguageLib.InfoIsDeletePerson'), this.$t('LanguageLib.DELETE_PERSON'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          this.$commonfun.console.log(this.selectPersonData)
          basicdataApi.DelPersonList('post', '/user/delete', this.selectPersonData)
            .then(res => {
              this.getPeopleListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.isAsc, this.gender, this.roleIds, this.ranks, this.isAdmin, this.isLoginProtection, this.isLock)
              this.$message({
                type: 'success',
                message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
              })
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('LanguageLib.DeletionCancelled')
          })
        })
    },
    // 组织选择
    selectionChange (selection) {
      this.selectPersonData = []
      for (let i = 0; i < selection.length; i++) {
        this.selectPersonData.push(selection[i].userId)
      }
      if (this.selectPersonData.length === 0) {
        this.delDisabled = true
      } else {
        this.delDisabled = false
      }
    },
    // 过滤点击
    drawerOpen () {
      this.drawer = true
      this.shaixuan = true
      // 获取角色列表
      basicdataApi.getRolesList('get', '/user/rlist')
        .then(res => {
          this.roleList = res.data
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    // 过滤关闭
    drawerClose () {
      this.drawer = false
      this.shaixuan = false
      this.checkedGender = ''
      this.checkedRoles = []
      this.checkedUserType = []
      this.checkedAdminStatus = ''
      this.checkedProtectStatus = ''
      this.checkedLockStatus = ''
    },
    // 点击精确搜索
    searchOrgList () {
      this.drawer = false
      this.isSearch = true
      this.gender = this.checkedGender === '' ? -1 : this.checkedGender
      this.roleIds = this.checkedRoles
      this.ranks = this.checkedUserType
      this.isAdmin = this.checkedAdminStatus === '' ? -1 : this.checkedAdminStatus
      this.isLoginProtection = this.checkedProtectStatus === '' ? -1 : this.checkedProtectStatus
      this.isLock = this.checkedLockStatus === '' ? -1 : this.checkedLockStatus
      this.currentPage = 1
      this.updataRouteQuery()
      this.getPeopleListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.isAsc, this.gender, this.roleIds, this.ranks, this.isAdmin, this.isLoginProtection, this.isLock)
    },
    // 清空搜索数据
    resetSearchData () {
      this.checkedGender = ''
      this.checkedRoles = []
      this.checkedUserType = []
      this.checkedAdminStatus = ''
      this.checkedProtectStatus = ''
      this.checkedLockStatus = ''
    },
    // 清除搜索状态
    clearSearchData () {
      this.shaixuan = false
      this.isSearch = false
      this.checkedGender = ''
      this.checkedRoles = []
      this.checkedUserType = []
      this.checkedAdminStatus = ''
      this.checkedProtectStatus = ''
      this.checkedLockStatus = ''
      this.gender = this.checkedGender === '' ? -1 : this.checkedGender
      this.roleIds = this.checkedRoles
      this.ranks = this.checkedUserType
      this.isAdmin = this.checkedAdminStatus === '' ? -1 : this.checkedAdminStatus
      this.isLoginProtection = this.checkedProtectStatus === '' ? -1 : this.isLoginProtection
      this.isLock = this.checkedLockStatus === '' ? -1 : this.checkedLockStatus
      this.currentPage = 1
      this.updataRouteQuery()
      this.getPeopleListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.isAsc, this.gender, this.roleIds, this.ranks, this.isAdmin, this.isLoginProtection, this.isLock)
    },
    // 点击添加人员
    addPerson () {
      this.$router.push('/basicdata/personnelmanagement/addperson?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&checkDomainId=' + this.domainId + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&isAsc=' + this.isAsc + '&gender=' + this.gender + '&roleIds=' + this.roleIds + '&ranks=' + this.ranks + '&isAdmin=' + this.isAdmin + '&isLoginProtection=' + this.isLoginProtection + '&isLock=' + this.isLock + '&type=add')
    },
    // 编辑人员
    editPerson (data, index, tableData) {
      this.$router.push('/basicdata/personnelmanagement/addperson?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&checkDomainId=' + this.domainId + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&isAsc=' + this.isAsc + '&gender=' + this.gender + '&roleIds=' + this.roleIds + '&ranks=' + this.ranks + '&isAdmin=' + this.isAdmin + '&isLoginProtection=' + this.isLoginProtection + '&isLock=' + this.isLock + '&type=edit&id=' + data.userId)
    },
    // 职位信息
    positionInformation (data, index, tableData) {
      this.$router.push('/basicdata/personnelmanagement/position?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&checkDomainId=' + this.domainId + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&isAsc=' + this.isAsc + '&gender=' + this.gender + '&roleIds=' + this.roleIds + '&ranks=' + this.ranks + '&isAdmin=' + this.isAdmin + '&isLoginProtection=' + this.isLoginProtection + '&isLock=' + this.isLock + '&type=add&userId=' + data.userId)
    },
    // 导出excal-人员
    exportExcal () {
      this.dialogExcal = true
    },
    // 导出跟进字段全部选中-人员
    handleCheckAllChange () {
      this.checkedFields = JSON.parse(JSON.stringify(this.Fields))
    },
    // 取消选中字段-人员
    delField (type) {
      for (let i = 0; i < this.checkedFields.length; i++) {
        if (type === this.checkedFields[i]) {
          this.checkedFields.splice(i, 1)
        }
      }
    },
    // 关闭对话框-人员
    closeDialogExcal () {
      this.dialogExcal = false
    },
    // 导出excal-人员职位
    exportExcalPosition () {
      this.dialogExcal2 = true
    },
    // 导出跟进字段全部选中-人员职位
    handleCheckAllChange2 () {
      this.checkedFields2 = JSON.parse(JSON.stringify(this.Fields2))
    },
    // 取消选中字段-人员职位
    delField2 (type) {
      for (let i = 0; i < this.checkedFields2.length; i++) {
        if (type === this.checkedFields2[i]) {
          this.checkedFields2.splice(i, 1)
        }
      }
    },
    // 关闭对话框-人员职位
    closeDialogExcal2 () {
      this.dialogExcal2 = false
    },
    // 下载导入模板
    downExcal () {
      basicdataApi.UserDownExcal('get', '/basicdata/exceltemplate?template=6')
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.DOWNLOAD_SUCCESSFUL')
          })
          this.dialogExcal = false
          var filename = 'User' + '_' + this.$commonfun.localStorage.getitem('lang') + '.xlsx'
          var a = document.createElement('a')
          var url = window.URL.createObjectURL(new Blob([res.data]))
          a.href = url
          a.download = filename
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    // 下载人员任职模板
    downExcal2 (type) {
      basicdataApi.UserPositionDownExcal('get', '/basicdata/exceltemplate?template=' + type)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.DOWNLOAD_SUCCESSFUL')
          })
          this.dialogExcal = false
          var filename = ''
          if (type === 21) {
            filename = 'WxUserBind' + '_' + this.$commonfun.localStorage.getitem('lang') + '.xlsx'
          } else {
            filename = 'UserDomainPostion' + '_' + this.$commonfun.localStorage.getitem('lang') + '.xlsx'
          }
          var a = document.createElement('a')
          var url = window.URL.createObjectURL(new Blob([res.data]))
          a.href = url
          a.download = filename
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    // 导入模板
    headers () {
      return { token: this.$commonfun.localStorage.getitem('token'), lang: this.$commonfun.localStorage.getitem('lang') }
    },
    handlePreview (file) {
    },
    beforeUpload (file) {
      const type = file.name.slice(file.name.lastIndexOf('.'), file.name.length)
      if (type !== '.xlsx' && type !== '.xls' && type !== '.XLSX' && type !== '.XLS') {
        this.$message.success(this.$t('LanguageLib.FILE_FORMAT_ERROR_PLEASE_UPLOAD_EXCAL'))
        return false
      }
    },
    // 上传失败
    onError (file) {
      this.$message.success(this.$t('LanguageLib.UPLOAD_FAILED'))
    },
    // 上传成功-导入人员
    onSuccess (file, response, EnumImportType) {
      this.FileData.FilePath = file[0]
      this.FileData.FileName = response.name
      this.FileData.EnumImportType = EnumImportType
      basicdataApi.importinfoImportUser('post', '/importinfo/create', this.FileData)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.FILE_ALREADY_UPLOAD_YOU_CAN_VIEW_IMPORT_ASSISTANT')
          })
          this.getPeopleListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.isAsc, this.gender, this.roleIds, this.ranks, this.isAdmin, this.isLoginProtection, this.isLock)
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    // 导出Excal
    submit () {
      this.loadingSave = true
      if (this.$commonfun.localStorage.getitem('qyuser') === 'false') {
        basicdataApi.userExport('post', '/user/Export', {
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          searchVal: this.searchText,
          domainId: this.domainId === '' ? null : this.domainId,
          roleIds: this.roleIds,
          ranks: this.ranks,
          isAdmin: this.isAdmin,
          isLoginProtection: this.isLoginProtection,
          isLock: this.isLock,
          sort: this.sort,
          isAsc: this.isAsc,
          gender: this.gender
        })
          .then(res => {
            this.$message({
              type: 'success',
              message: this.$t('LanguageLib.EXPORT_SUCCESSFULLY')
            })
            this.dialogExcal = false
            // 获取当前日期
            var today = new Date()
            var Month = today.getMonth() + 1
            var day = today.getDate()
            if (Month < 10) {
              Month = '0' + Month
            }
            if (day < 10) {
              day = '0' + day
            }
            var hours = today.getHours() < 10 ? '0' + today.getHours() : today.getHours()
            var minute = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()
            var second = today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds()
            var milliSeconds = today.getMilliseconds()
            var currentDay = today.getFullYear() + '' + Month + '' + day + '' + hours + '' + minute + '' + second + '' + milliSeconds
            var filename = 'User' + '_' + currentDay + '.xlsx'
            var a = document.createElement('a')
            var url = window.URL.createObjectURL(new Blob([res.data]))
            a.href = url
            a.download = filename
            a.click()
            window.URL.revokeObjectURL(url)
            this.loadingSave = false
          })
          .catch(err => {
            this.loadingSave = false
            this.$commonfun.console.log(err)
          })
      } else {
        // 企微登录扫码导出
        basicdataApi.ExportWXTranslateUser('post', '/user/exportWXTranslate', {
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          searchVal: this.searchText,
          domainId: this.domainId === '' ? null : this.domainId,
          roleIds: this.roleIds,
          ranks: this.ranks,
          isAdmin: this.isAdmin,
          isLoginProtection: this.isLoginProtection,
          isLock: this.isLock,
          sort: this.sort,
          isAsc: this.isAsc,
          gender: this.gender
        })
          .then(res => {
            var time = 0
            var timeId = setInterval(() => {
              time++
              basicdataApi.GetWXTranslateURL('get', '/export/GetWXTranslateURL', {
                jobId: res.data.jobId
              })
                .then(result => {
                  if (result.data.url !== null) {
                    window.clearInterval(timeId)
                    this.$message({
                      type: 'success',
                      message: this.$t('LanguageLib.EXPORT_SUCCESSFULLY')
                    })
                    this.dialogExcal = false
                    // 获取当前日期
                    var today = new Date()
                    var Month = today.getMonth() + 1
                    var day = today.getDate()
                    if (Month < 10) {
                      Month = '0' + Month
                    }
                    if (day < 10) {
                      day = '0' + day
                    }
                    var hours = today.getHours() < 10 ? '0' + today.getHours() : today.getHours()
                    var minute = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()
                    var second = today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds()
                    var milliSeconds = today.getMilliseconds()
                    var currentDay = today.getFullYear() + '' + Month + '' + day + '' + hours + '' + minute + '' + second + '' + milliSeconds
                    var filename = 'User' + '_' + currentDay + '.xlsx'
                    var a = document.createElement('a')
                    a.href = result.data.url
                    a.download = filename
                    a.click()
                    window.URL.revokeObjectURL(result.data.url)
                    this.loadingSave = false
                  } else {
                    if (time === 5) {
                      window.clearInterval(timeId)
                      this.dialogExcal = false
                      this.loadingSave = false
                      this.$message({
                        type: 'error',
                        message: this.$t('LanguageLib.EXPORT_FAILED')
                      })
                    }
                  }
                })
                .catch(err => {
                  this.loadingSave = false
                  this.$commonfun.console.log(err)
                })
            }, 2000)
          })
          .catch(err => {
            this.loadingSave = false
            this.$commonfun.console.log(err)
          })
      }
    },
    // 导出人员职位Excal
    submit2 () {
      this.loadingSave2 = true
      if (this.$commonfun.localStorage.getitem('qyuser') === 'false') {
        basicdataApi.userExportPosition('post', '/user/udp/Export', {
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          searchVal: this.searchText,
          domainId: this.domainId === '' ? null : this.domainId,
          roleIds: this.roleIds,
          ranks: this.ranks,
          isAdmin: this.isAdmin,
          isLoginProtection: this.isLoginProtection,
          isLock: this.isLock,
          sort: this.sort,
          isAsc: this.isAsc,
          gender: this.gender
        })
          .then(res => {
            this.$message({
              type: 'success',
              message: this.$t('LanguageLib.EXPORT_SUCCESSFULLY')
            })
            this.dialogExcal2 = false
            // 获取当前日期
            var today = new Date()
            var Month = today.getMonth() + 1
            var day = today.getDate()
            if (Month < 10) {
              Month = '0' + Month
            }
            if (day < 10) {
              day = '0' + day
            }
            var hours = today.getHours() < 10 ? '0' + today.getHours() : today.getHours()
            var minute = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()
            var second = today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds()
            var milliSeconds = today.getMilliseconds()
            var currentDay = today.getFullYear() + '' + Month + '' + day + '' + hours + '' + minute + '' + second + '' + milliSeconds
            var filename = 'UserDomainPostion' + '_' + currentDay + '.xlsx'
            var a = document.createElement('a')
            var url = window.URL.createObjectURL(new Blob([res.data]))
            a.href = url
            a.download = filename
            a.click()
            window.URL.revokeObjectURL(url)
            this.loadingSave2 = false
          })
          .catch(err => {
            this.loadingSave2 = false
            this.$commonfun.console.log(err)
          })
      } else {
        // 企微登录扫码导出
        basicdataApi.ExportWXTranslateUserUdp('post', '/user/udp/exportWXTranslate', {
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          searchVal: this.searchText,
          domainId: this.domainId === '' ? null : this.domainId,
          roleIds: this.roleIds,
          ranks: this.ranks,
          isAdmin: this.isAdmin,
          isLoginProtection: this.isLoginProtection,
          isLock: this.isLock,
          sort: this.sort,
          isAsc: this.isAsc,
          gender: this.gender
        })
          .then(res => {
            var time = 0
            var timeId = setInterval(() => {
              time++
              basicdataApi.GetWXTranslateURL('get', '/export/GetWXTranslateURL', {
                jobId: res.data.jobId
              })
                .then(result => {
                  if (result.data.url !== null) {
                    window.clearInterval(timeId)
                    this.$message({
                      type: 'success',
                      message: this.$t('LanguageLib.EXPORT_SUCCESSFULLY')
                    })
                    this.dialogExcal2 = false
                    // 获取当前日期
                    var today = new Date()
                    var Month = today.getMonth() + 1
                    var day = today.getDate()
                    if (Month < 10) {
                      Month = '0' + Month
                    }
                    if (day < 10) {
                      day = '0' + day
                    }
                    var hours = today.getHours() < 10 ? '0' + today.getHours() : today.getHours()
                    var minute = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()
                    var second = today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds()
                    var milliSeconds = today.getMilliseconds()
                    var currentDay = today.getFullYear() + '' + Month + '' + day + '' + hours + '' + minute + '' + second + '' + milliSeconds
                    var filename = 'UserDomainPostion' + '_' + currentDay + '.xlsx'
                    var a = document.createElement('a')
                    a.href = result.data.url
                    a.download = filename
                    a.click()
                    window.URL.revokeObjectURL(result.data.url)
                    this.loadingSave2 = false
                  } else {
                    if (time === 5) {
                      window.clearInterval(timeId)
                      this.dialogExcal2 = false
                      this.loadingSave2 = false
                      this.$message({
                        type: 'error',
                        message: this.$t('LanguageLib.EXPORT_FAILED')
                      })
                    }
                  }
                })
                .catch(err => {
                  this.loadingSave2 = false
                  this.$commonfun.console.log(err)
                })
            }, 2000)
          })
          .catch(err => {
            this.loadingSave2 = false
            this.$commonfun.console.log(err)
          })
      }
    }
  },
  watch: {
  }
}
</script>

<style lang="scss">
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.person{
  width:100%;
  height: 100%;
  .el-divider--vertical{
    height: 30px;
    margin: 0 10px;
  }
  .el-select{
    display: block;
    width: 100%;
  }
}
.person .left{
  background: #fff;
  width: 20%;
  float:left;
  height: 100%;
  border-right: 1px solid #f2f2f2;
  .treeBox{
    height: calc( 100% - 50px );
    overflow: auto;
    width: 100%;
  }
  .fifter{
    padding: 10px 0 10px 6%;
    line-height: 30px;
   .el-input{
      width: 60%;
    }
    .el-button--text{
      margin-left: 2.5%;
      padding: 2% 0;
      width: 20%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.person .right{
  width: 80%;
  margin-left: 20%;
  height: 100%;
  .operation{
    background: #fff;
    height: 30px;
    padding: 10px 0 10px 20px;
    border-bottom: 1px solid #f2f2f2;
    border-top: 1px solid #f2f2f2;
    .operationBtn{
      width: auto;
      display: inline-block;
      float:left;
      position: relative;
      .el-button{
        height: 30px;
        padding: 7px 20px;
      }
      .BatchSetting{
        background: #fff;
        color: #000000;
        position:absolute;
        left: 0;
        top: 30px;
        font-size: 14px;
        text-align:center;
        box-shadow:0px 3px 6px 0px rgba(0,0,0,0.2);
        border-radius:2px;
        z-index: 99;
        li{
          line-height: 30px;
          cursor: pointer;
          padding: 0 10px;
        }
      }
      .exportType{
        background: #fff;
        color: #666666;
        position:absolute;
        right: 0;
        top: 30px;
        min-width:100px;
        font-size: 14px;
        text-align:center;
        box-shadow:0px 3px 6px 0px rgba(0,0,0,0.2);
        border-radius:2px;
        z-index: 99;
        li{
          line-height: 30px;
          cursor: pointer;
          padding: 0 10px;
        }
        .upload{
          position: absolute;
          top: 30px;
          width: 100%;
          opacity: 0;
          .el-upload{
            width: 100%;
            button{
              width: 100%;
              padding-left: 0;
            }
          }
        }
        .upload2{
          position: absolute;
          top: 120px;
          width: 100%;
          opacity: 0;
          .el-upload{
            width: 100%;
            button{
              width: 100%;
              padding-left: 0;
            }
          }
        }
      }
    }
    .operationSearch{
      float:right;
      padding-right: 51px;
      position: relative;
      .shaixuan{
        color: #999999;
        height: 15px;
        width: 15px;
        position: relative;
        top: 2px;
        margin-left: 10px;
        margin-right: 10px;
        font-weight: 600;
      }
      .shaixuan1{
        color: #3BC6B9;
      }
      .el-input{
        width: 160px;
        .el-input__inner{
          height: 30px;
          line-height: 30px;
          border-radius: 20px;
        }
      }
      .el-icon-search{
        line-height: 30px;
      }
    }
  }
  .tableParent{
    height: calc( 100% - 98px );
  }
  .el-pagination{
    padding: 8px 15px 5px;
    height: 35px;
    background: #fff;
  }
}
.person .drawerTitle{
  height:25px;
  font-size:18px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(77,77,77,1);
  line-height:25px;
  margin-bottom: 20px;
}
.person .drawerText{
  height:16px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(77,77,77,1);
  line-height:16px;
  margin-bottom: 5px;
}
.cell{
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
.el-button--primary{
  background-color:#3BC6B9;
  color:#fff;
  border:none;
  margin-left: 10px;
}
.el-button--primary:hover{
  background-color:#3BC6B9;
  color:#fff;
  border:none;
}
/*.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #3BC6B9 !important;
  border-color: #3BC6B9 !important;
}*/
// 对于树组件配置特有的css
.el-tree-node>.el-tree-node__children{
  overflow: unset;
}
.el-tree-node__content{
  height: 48px;
}
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
  background-color: #F6F6F6
}
// .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>span:last-child{
//   color: #3BC6B9 !important;
// }
// .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>ww-open-data{
//   color: #3BC6B9 !important;
// }
// 更改表格的滚动条样式
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar,
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb,
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
  background: #E1E1E1;
}
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track,
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
  border-radius: 5px;
  background: #fff;
}
// 抽屉组件样式修改
.el-drawer.rtl{
  outline: none;
}
.el-drawer__wrapper{
  top: 172px;
  bottom: 18px;
  /*right: 20px;*/
}
section.el-drawer__body{
  padding: 20px;
  .el-input{
    margin-bottom: 15px;
  }
}
.el-drawer__container{
  outline: none;
}
.colorG{
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(59,198,185,1);
  line-height:20px;
}
.el-table .descending .sort-caret.descending{
}
.el-table .ascending .sort-caret.ascending{
  border-bottom-color: #3BC6B9;
}
.el-pager li.active{
  color: #3BC6B9;
}
.el-table__fixed-body-wrapper .el-table__body{
    padding-bottom: 10px;
}
.filterContent{
  height: calc(100% - 165px);
  overflow: hidden;
  overflow-y: auto;
}
.filterContent::-webkit-scrollbar{
    width: 10px;
    height: 10px;
}
.filterContent::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
  background: #E1E1E1;
}
.filterContent::-webkit-scrollbar-track {
  border-radius: 5px;
  background: #fff;
}
.el-table-column--selection{
  text-align: center !important;
}
.el-tooltip__popper.is-light{
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  border: 1px solid #E4E7ED !important;
  background-color: #fff;
  color: #000;
  .popper__arrow{
    border-top-color: #E4E7ED;
    border: #E4E7ED;
  }
  .popper__arrow::after{
    border-top-color: #fff;
  }
}
/*.table-fixed{
  .el-table__fixed-right{
    height:100% !important;
    right: 0 !important;
  }
  .el-table__fixed{
    height: 100% !important;
  }
}*/
.resetDialog{
  .el-dialog{
    width: 420px !important;
    .el-dialog__body{
      padding: 10px 20px 30px;
      .parent{
        margin: 15px 0;
      }
    }
  }
}
.ExcalDialog{
  .el-dialog{
    width: 1000px !important;
    .el-dialog__body{
      height: 350px;
      overflow-y: auto;
    }
    .checkFiled{
      height: 100%;
      border-right: 1px solid #D8DCE6;
      width: calc(70% - 21px);
      padding-right: 20px;
      float: left;
      h4 {
        font-size: 14px;
        color: #999999;
        font-weight: normal;
        padding-bottom: 10px;
        border-bottom: 1px solid #D8DCE6;
        margin-bottom: 15px;
      }
      .contentTop{
        margin-bottom: 15px;
      }
      .el-checkbox{
        margin-bottom: 15px;
      }
    }
    .showFiled{
      width: calc(30% - 20px);
      float: left;
      padding-left: 20px;
      li{
        margin-top: 10px;
        position: relative;
        span{
          padding-right: 20px;
          display: block;
        }
        .el-icon-close{
          position: absolute;
          right: 0;
          top: 3px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
